import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import Register from "../../components/Register";
import TradingViewWidget from "./TradingViewWidget";

const apiUrl = process.env.REACT_APP_API_REST_URL;

const Dashboard = ({ SelectedIcon, setSource }) => {
  const navigate = useNavigate();
  const [referralcount, setreferralcount] = useState(null);
  const [totalreferralpoints, setTotalreferralpoints] = useState(null);
  const [totalcount, setTotalcount] = useState(null);

  const { token } = useAuth();

  const handleClick = () => {
    navigate("/addreferral");
  };
  const handleClickdashboard = () => {
    SelectedIcon("Referrals");
    setSource("Referrals");
  };

  const handleClickClient = () => {
    SelectedIcon("Referrals");
    setSource("clients");
  };

  const headers = {
    "x-access-token": token,
  };

  const getdata = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/CCE/api/v1/referalEngine/referralCount`,
        {
          headers,
        }
      );
      console.log("response dataaaa", response);
      setreferralcount(response.data.response.clientCount);
      setTotalcount(response.data.response.totalCount);
      setTotalreferralpoints(response.data.response.totalReferralPoints);
    } catch (error) {
      console.error("Error updating user:", error.message);
    }
  };

  useEffect(() => {
    getdata();
  }, []);
  return (
    <Box sx={{ display: "flex", marginTop: "-20px" }}>
      <Register />
      <Box sx={styles.formboxleft}>
        <Box
          style={{
            width: "85%",
            height: "80%",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Box sx={styles.bigbtn}>
            <h2 onClick={handleClickdashboard} style={{ marginTop: "50px" }}>
              {totalcount ? totalcount : 0}
              <br />
              Total Referrals
            </h2>
          </Box>
          <Box sx={styles.bigbtn}>
            <h2 onClick={handleClickClient} style={{ marginTop: "50px" }}>
              {referralcount ? referralcount : 0}
              <br />
              Converted Referrals
            </h2>
          </Box>
          <Box sx={styles.bigbtn}>
            <h2 onClick={handleClickdashboard} style={{ marginTop: "50px" }}>
              {totalreferralpoints ? totalreferralpoints : 0}
              <br />
              Loyalties Points
            </h2>
          </Box>
        </Box>
        <Box style={{ width: "15%", height: "100%" }}>
          <Button onClick={handleClick} sx={styles.btn}>
            Add New Referral
          </Button>
        </Box>
      </Box>
      <Box sx={styles.formboxright}>
        <TradingViewWidget />
      </Box>
    </Box>
  );
};

export default Dashboard;

const styles = {
  formboxleft: {
    position: "absolute",
    top: "10%",
    left: "0%",
    borderRadius: "8px",
    height: "600px",
    width: "75%",
    display: "flex",
  },
  formboxright: {
    position: "absolute",
    top: "8%",
    left: "75%",
    right: "5%",
    background: "#FFFFFF",
    borderRadius: "8px",
    height: "640px",
    width: "25%",
    marginRight: "40px",
  },
  btn: {
    marginTop: "1em",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  bigbtn: {
    color: "white",
    height: "130px",
    width: "340px",
    borderRadius: "8px",
    marginTop: "40px",
    marginLeft: "400px",
    backgroundColor: "#00CED1",
    justifyContent: "center",
    textAlign: "center",
    cursor: "pointer",
  },
};
